import React from 'react';
import type { AuditPayload, HealthSegment } from '../types';

const SEGMENT_TONE: Record<HealthSegment, { label: string; tone: string; color: string }> = {
  unmanaged: { label: '完全未対応',   tone: '緊急対応推奨', color: 'text-rose-700' },
  amateur:   { label: '素人運用',     tone: '改善余地大',   color: 'text-amber-700' },
  agency:    { label: '代理店運用中', tone: '競合監視中',   color: 'text-brand-700' },
  optimized: { label: '強力対策済',   tone: '現状維持',     color: 'text-leaf-700' },
};

const AuditTitle: React.FC<{ payload: AuditPayload }> = ({ payload }) => {
  const seg = SEGMENT_TONE[payload.health_segment];
  return (
    <header className="bg-white border-b border-slate-200 px-6 py-5">
      <div className="text-[11px] text-slate-500 mb-2 tracking-[0.08em] uppercase">
        パーソナルジム業界専門 / Local SEO Audit
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mb-2 leading-tight">{payload.store_title}</h1>
      <p className="text-[13px] text-slate-500 leading-relaxed mb-3">
        {payload.station}駅エリアにおける「{payload.keyword}」検索結果での貴店ポジションを分析し、
        Google マップ上位表示に向けた具体的な改善ポイントを提示する診断レポートです。
      </p>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px]">
        <span className="text-slate-500">エリア: <strong className="text-slate-900">{payload.station}駅</strong></span>
        <span className="text-slate-500">キーワード: <strong className="text-slate-900">{payload.keyword}</strong></span>
        {payload.primary_type && (
          <span className="text-slate-500">カテゴリ: <strong className="text-slate-900">{payload.primary_type}</strong></span>
        )}
        <span className={`font-semibold ${seg.color}`}>
          {seg.label} — {seg.tone}
        </span>
      </div>
    </header>
  );
};

export default AuditTitle;
